var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef, useState } from "react";
import { useResolvePublisher } from "./useResolvePublisher";
export var useOwnerPublisherHydration = function (initialValues, setFormValue) {
    var _a, _b;
    var resolvePublisherById = useResolvePublisher().resolvePublisherById;
    var _c = useState([]), ownerSelectOptions = _c[0], setOwnerSelectOptions = _c[1];
    var _d = useState([]), publisherSelectOptions = _d[0], setPublisherSelectOptions = _d[1];
    var mergeSelectOptions = function (current, incoming) {
        var merged = new Map(current.map(function (opt) { return [opt.value, opt]; }));
        incoming.forEach(function (opt) { return merged.set(opt.value, opt); });
        return Array.from(merged.values());
    };
    var lastResolvedOwnerIdRef = useRef(null);
    var lastResolvedPublisherIdListKeyRef = useRef(null);
    var initialPublisherIdListKey = JSON.stringify(((_a = initialValues === null || initialValues === void 0 ? void 0 : initialValues.titlePublishers) !== null && _a !== void 0 ? _a : []).map(function (entry) { var _a, _b; return (_b = (_a = entry === null || entry === void 0 ? void 0 : entry.publisher) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null; }));
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var ownerValueFromForm, resolvedOwner_1, _a, initialTitlePublishers, nextPublisherOptions, index, publisherFieldValue, publisherId, resolvedPublisher, _b;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        ownerValueFromForm = initialValues === null || initialValues === void 0 ? void 0 : initialValues.owner;
                        if (!((ownerValueFromForm === null || ownerValueFromForm === void 0 ? void 0 : ownerValueFromForm.id) &&
                            lastResolvedOwnerIdRef.current !== ownerValueFromForm.id)) return [3 /*break*/, 4];
                        if (!ownerValueFromForm.name) return [3 /*break*/, 1];
                        _a = ownerValueFromForm;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, resolvePublisherById(ownerValueFromForm.id)];
                    case 2:
                        _a = _e.sent();
                        _e.label = 3;
                    case 3:
                        resolvedOwner_1 = _a;
                        if (resolvedOwner_1) {
                            setOwnerSelectOptions(function (previous) {
                                return mergeSelectOptions(previous, [
                                    {
                                        value: resolvedOwner_1.id,
                                        label: resolvedOwner_1.name || resolvedOwner_1.id,
                                    },
                                ]);
                            });
                            setFormValue("owner", resolvedOwner_1, {
                                shouldDirty: false,
                                shouldTouch: false,
                                shouldValidate: false,
                            });
                            lastResolvedOwnerIdRef.current = resolvedOwner_1.id;
                        }
                        _e.label = 4;
                    case 4:
                        initialTitlePublishers = (_c = initialValues === null || initialValues === void 0 ? void 0 : initialValues.titlePublishers) !== null && _c !== void 0 ? _c : [];
                        if (!initialTitlePublishers.length)
                            return [2 /*return*/];
                        if (initialPublisherIdListKey === lastResolvedPublisherIdListKeyRef.current)
                            return [2 /*return*/];
                        lastResolvedPublisherIdListKeyRef.current = initialPublisherIdListKey;
                        nextPublisherOptions = [];
                        index = 0;
                        _e.label = 5;
                    case 5:
                        if (!(index < initialTitlePublishers.length)) return [3 /*break*/, 10];
                        publisherFieldValue = (_d = initialTitlePublishers[index]) === null || _d === void 0 ? void 0 : _d.publisher;
                        publisherId = publisherFieldValue === null || publisherFieldValue === void 0 ? void 0 : publisherFieldValue.id;
                        if (!publisherId) return [3 /*break*/, 9];
                        if (!(publisherFieldValue === null || publisherFieldValue === void 0 ? void 0 : publisherFieldValue.name)) return [3 /*break*/, 6];
                        _b = publisherFieldValue;
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, resolvePublisherById(publisherId)];
                    case 7:
                        _b = _e.sent();
                        _e.label = 8;
                    case 8:
                        resolvedPublisher = _b;
                        if (resolvedPublisher) {
                            setFormValue("titlePublishers.".concat(index, ".publisher"), resolvedPublisher, {
                                shouldDirty: false,
                                shouldTouch: false,
                                shouldValidate: false,
                            });
                            nextPublisherOptions.push({
                                value: resolvedPublisher.id,
                                label: resolvedPublisher.name || resolvedPublisher.id,
                            });
                        }
                        _e.label = 9;
                    case 9:
                        index++;
                        return [3 /*break*/, 5];
                    case 10:
                        if (nextPublisherOptions.length) {
                            setPublisherSelectOptions(function (previous) {
                                return mergeSelectOptions(previous, nextPublisherOptions);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [
        (_b = initialValues === null || initialValues === void 0 ? void 0 : initialValues.owner) === null || _b === void 0 ? void 0 : _b.id,
        initialPublisherIdListKey,
        resolvePublisherById,
        setFormValue,
    ]);
    return {
        ownerSelectOptions: ownerSelectOptions,
        setOwnerSelectOptions: setOwnerSelectOptions,
        publisherSelectOptions: publisherSelectOptions,
        setPublisherSelectOptions: setPublisherSelectOptions,
        ownerOptions: ownerSelectOptions,
        setOwnerOptions: setOwnerSelectOptions,
        publisherOptions: publisherSelectOptions,
        setPublisherOptions: setPublisherSelectOptions,
    };
};
